import colors from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	title: {
		textTransform: "uppercase"
	},
	tableCell: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5)
	},
	noContactsText: {
		color: colors.grayScale[4],
		fontWeight: 300,
		lineHeight: "1.5em",
		textTransform: "uppercase",
		[theme.breakpoints.down("sm")]: {
			textAlign: "center"
		}
	},
	clearContactsChip: {
		backgroundColor: "#FBEECC",
		color: colors.grayScale[4],
		fontSize: 14,
		height: 20
	}
}))

export default useStyles
